/* @flow */
import React from 'react';

import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import Row from 'components/UIKit/Flex/Row';

import CaseIcon from 'components/icons/CaseIcon';

export default function DropdownButton({
  children, style, PrefixComponent, PostfixComponent, ...rest
}: any): React.Element {
  return (
    <ButtonTemplate
      PrefixComponent={PrefixComponent}
      PostfixComponent={PostfixComponent}
      style={style}
      { ...rest }
    >
      { children }
   </ButtonTemplate>
  );
}
